import { Check, Crown, Sparkles } from "lucide-react";
import { AppShot } from "./AppShot";
import { TopoLines } from "./Decor";

const FREE = [
  "Workout logging, programs and exercise library",
  "Nutrition, macros, fiber and water tracking",
  "Bodyweight, goals and core progress history",
  "30 complete curated recipes",
  "Guest access without mandatory registration",
];

const PRO = [
  "Adaptive weekly planning",
  "19,000+ FatSecret-powered recipes",
  "Training Intelligence and progression context",
  "Advanced progress trends",
  "Adaptive Nutrition and Progress Drivers",
];

const PlanList = ({ title, eyebrow, items, pro = false }) => (
  <div className={`rounded-[1.75rem] border p-7 sm:p-8 ${pro ? "border-[#F2D9A6]/30 bg-[#0B3A31]" : "border-[#8BE8C7]/20 bg-[#062B24]"}`}>
    <div className="flex items-center justify-between gap-4">
      <div>
        <p className={`eyebrow ${pro ? "text-[#F2D9A6]" : "text-[#8BE8C7]"}`}>{eyebrow}</p>
        <h3 className="mt-2 text-2xl font-bold text-[#F3F7F5]">{title}</h3>
      </div>
      <span className={`grid h-11 w-11 place-items-center rounded-2xl ${pro ? "bg-[#F2D9A6]/10 text-[#F2D9A6]" : "bg-[#8BE8C7]/10 text-[#8BE8C7]"}`}>
        {pro ? <Crown size={21} aria-hidden="true" /> : <Check size={21} aria-hidden="true" />}
      </span>
    </div>
    <ul className="mt-7 space-y-4">
      {items.map((item) => (
        <li key={item} className="flex items-start gap-3 text-sm font-medium leading-relaxed text-[#D7E5E0]">
          <span className={`mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full ${pro ? "bg-[#F2D9A6]/10 text-[#F2D9A6]" : "bg-[#8BE8C7]/10 text-[#8BE8C7]"}`}>
            {pro ? <Sparkles size={12} aria-hidden="true" /> : <Check size={13} aria-hidden="true" />}
          </span>
          {item}
        </li>
      ))}
    </ul>
  </div>
);

export const Pro = () => (
  <section id="pro" data-testid="pro-section" className="relative scroll-mt-20 overflow-hidden bg-[#041F1A] py-20 lg:py-28">
    <TopoLines className="pointer-events-none absolute -right-24 top-4 text-[#8BE8C7] opacity-[0.08]" />
    <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-[1.08fr_0.92fr]">
        <div className="reveal">
          <p className="eyebrow text-[#8BE8C7]">Free and Pro</p>
          <h2 className="section-title mt-3 max-w-2xl text-4xl text-[#F3F7F5] sm:text-5xl lg:text-6xl">
            Free does the tracking. Pro helps you adapt.
          </h2>
          <p className="mt-5 max-w-xl text-base font-medium leading-relaxed text-[#B8C8C3] md:text-lg">
            The everyday tools stay free. Pro adds planning, broader recipe discovery and careful interpretation of the history you choose to build.
          </p>
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-[#819D95]">
            Store pricing is localized by Google Play or the App Store. Subscription availability depends on your release channel.
          </p>
        </div>
        <div className="reveal flex justify-center" style={{ transitionDelay: "100ms" }}>
          <AppShot
            src="/screenshots/aktua-pro.webp"
            alt="AKTUA Pro screen listing adaptive planning, recipe discovery, training intelligence and progress trends"
            className="pro-shot"
          />
        </div>
      </div>

      <div id="pro-comparison" data-testid="pro-comparison" className="mt-16 grid gap-5 lg:grid-cols-2">
        <PlanList eyebrow="Always useful" title="AKTUA Free" items={FREE} />
        <PlanList eyebrow="Optional membership" title="AKTUA Pro" items={PRO} pro />
      </div>
    </div>
  </section>
);
